import PropTypes from 'prop-types';
import SliderFilter from './SliderFilter';
import { getPriceText } from '@/utils/categUtils';
import { PRICE_FILTER_DEFAULT, FILTERS_TYPE } from '@/constants/categ';

export const PriceFilter = (
  {
    t,
    min = PRICE_FILTER_DEFAULT.min,
    sliderDefaultCursorMin = PRICE_FILTER_DEFAULT.min,
    max = PRICE_FILTER_DEFAULT.max,
    sliderDefaultCursorMax = PRICE_FILTER_DEFAULT.max,
    step = PRICE_FILTER_DEFAULT.step,
    onChange,
    locale,
    currency
  }) => {
  const customOnChange = (value) => {
    onChange({
      nameId: FILTERS_TYPE.PRICE,
      price: true,
      minPrice: value.minValue,
      maxPrice: value.maxValue,
      check: true
    });
  };

  return (
    <SliderFilter
      min={min}
      sliderDefaultCursorMin={+sliderDefaultCursorMin}
      max={max}
      sliderDefaultCursorMax={+sliderDefaultCursorMax}
      step={step}
      onChange={customOnChange}
      formatValue={(val, addPlusSign) => getPriceText(t, [val], locale, currency, addPlusSign)}
    />
  );
};

PriceFilter.propTypes = {
  t: PropTypes.func.isRequired,
  min: PropTypes.number,
  sliderDefaultCursorMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  max: PropTypes.number,
  sliderDefaultCursorMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  step: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired
};

export default PriceFilter;
